import moment from "moment";
import Head from "next/head";
import { useRouter } from "next/router";

export default function MetaSection({ title, desc, keyWords, imageUrl = null, schema }) {
    const router = useRouter();
    const defaultSchema = {
        "@context": "http://schema.org",
        "@type": "Organization",
        url: "https://univest.in/",
        name: "Univest",
        logo: imageUrl ?? "https://storage.googleapis.com/app-assets-univest/website-assets/UnivestLogo.jpg",
        address: {
            "@type": "PostalAddress",
            addressLocality: "Gurugram, Haryana",
            postalCode: "122002",
            streetAddress: "10, Poorvi Marg, DLF Phase 2, Sector 25, Gurugram, Haryana 122002"
        },
        email: "support@univest.in",
        telephone: "+91-8800049790",
        sameAs: [
            "https://www.facebook.com/Univest.in",
            "https://www.instagram.com/univest.in/",
            "https://twitter.com/UnivestIN",
            "http://linkedin.com/company/univest-in",
            "https://www.youtube.com/channel/UCRlFx-WxA4yY7Y33SRZaQ4w",
            "https://www.crunchbase.com/organization/univest-557f"
        ],
        contactPoint: [
            {
                "@type": "ContactPoint",
                telephone: "+91-8800049790",
                contactType: "Customer Service"
            }
        ],
        foundingDate: "2022",
        founders: [
            {
                "@type": "Person",
                name: "Pranit Arora",
                id: "https://in.linkedin.com/in/pranit-arora-1b505422"
            },
            {
                "@type": "Person",
                name: "Avneet Dhamija",
                id: "https://in.linkedin.com/in/avneet-dhamija"
            },
            {
                "@type": "Person",
                name: "Vikash Agarwal",
                id: "https://in.linkedin.com/in/vikashagrawal1985"
            }
        ],
        funder: [
            {
                "@type": "Corporation",
                legalName: "Trinity media Group",
                url: "https://www.vccircle.com/company/trinity-media-group"
            }
        ],
        potentialAction: {
            "@type": "SearchAction",
            target: "https://univest.in/stocks/{symbol}",
            "query-input": "required symbol"
        }
    };
    return (
        <>
            <Head>
                <title>{title ?? "Stock Market Investment and Trade Ideas By SEBI Reg. Analyst"}</title>
                <meta
                    name="description"
                    content={
                        desc ??
                        "Maximise your profits in stock market with the help of SEBI Registered Analyst of Univest. Start boosting your stock market Investments today with Univest."
                    }
                />
                <meta
                    name="keywords"
                    content={
                        keyWords ??
                        "Stock Market, Share Market, Stock Market Investment, Stock Market Ideas, Stock Market Trade Ideas, Share Market Investment, Share Market Ideas, Share Market Trade Ideas, Stock Market Research analyst, SEBI Registered Stock Analyst"
                    }
                />
                <meta charSet="utf-8" />
                <meta name="theme-color" content="#00439D" />
                <meta name="msapplication-navbutton-color" content="#00439D" />
                <meta name="apple-mobile-web-app-status-bar-style" content="#00439D" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, user-scalable=no"
                />

                <meta name="google-play-app" content="app-id=com.univest.capp" />
                <meta property="fb:app_id" content="6443753518" />
                <meta property="al:web:should_fallback" content="true" />
                <meta
                    name="apple-itunes-app"
                    content={`app-id=com.univest.capp, app-argument=https://univest.in${router?.asPath}`}
                />

                <meta
                    property="al:android:url"
                    content="https://play.google.com/store/apps/details?id=com.univest.capp"
                />
                <meta property="al:android:package" content="com.univest.capp" />
                <meta property="al:android:app_name" content="Univest" />

                <meta
                    property="al:ios:url"
                    content="https://apps.apple.com/us/app/univest-empowering-wealth/id6443753518"
                />
                <meta property="al:ios:app_store_id" content="6443753518" />
                <meta property="al:ios:app_name" content="Univest" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:image"
                    content={
                        imageUrl ?? "https://storage.googleapis.com/app-assets-univest/website-assets/UnivestLogo.jpg"
                    }
                />
                <meta name="twitter:site" content="UnivestIN" />
                <meta name="twitter:creator" content="UnivestIN" />
                <meta
                    name="twitter:title"
                    content={title ?? "Stock Market Investment and Trade Ideas By SEBI Reg. Analyst"}
                />
                <meta
                    name="twitter:description"
                    content={
                        desc ??
                        "Maximise your profits in stock market with the help of SEBI Registered Analyst of Univest. Start boosting your stock market Investments today with Univest."
                    }
                />
                <meta name="twitter:label1" content="Est. reading time" />
                <meta name="twitter:data1" content="3 minutes" />
                <meta name="twitter:label2" content="Time to read" />
                <meta name="twitter:data2" content="Less than a minute" />
                <meta name="twitter:app:country" content="IN" />
                <meta name="twitter:app:name:iphone" content="Univest" />
                <meta name="twitter:app:id:iphone" content="6443753518" />
                <meta
                    name="twitter:app:url:iphone"
                    content="https://apps.apple.com/in/app/univest-stocks-investment/id6443753518"
                />
                <meta name="twitter:app:name:googleplay" content="Univest" />
                <meta name="twitter:app:id:googleplay" content="com.univest.capp" />
                <meta
                    name="twitter:app:url:googleplay"
                    content="https://play.google.com/store/apps/details?id=com.univest.capp"
                />
                <meta name="robots" content="index,follow" />
                <meta name="googlebot" content="index,follow" />
                <link rel="canonical" href={`https://univest.in${router?.asPath}`} />

                <meta property="og:locale" content="en_IN" />
                <meta property="og:url" content={`https://univest.in${router?.asPath}`} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:image"
                    content={
                        imageUrl ?? "https://storage.googleapis.com/app-assets-univest/website-assets/UnivestLogo.jpg"
                    }
                />
                <meta property="og:site_name" content="Univest" />
                <meta
                    name="og:title"
                    content={title ?? "Stock Market Investment and Trade Ideas By SEBI Reg. Analyst"}
                />
                <meta
                    name="og:description"
                    content={
                        desc ??
                        "Maximise your profits in stock market with the help of SEBI Registered Analyst of Univest. Start boosting your stock market Investments today with Univest."
                    }
                />
                <meta property="og:updated_time" content={`${moment().format("yyyy-mm-DD")}T13:57:34+00:00`} />
                <meta
                    property="og:image:secure_url"
                    content={
                        imageUrl ?? "https://storage.googleapis.com/app-assets-univest/website-assets/UnivestLogo.jpg"
                    }
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:alt" content="Univest" />
                <meta property="og:image:type" content="image/jpeg" />
                <meta
                    property="og:image:alt"
                    content="Stock Market Investment and Trade Ideas By SEBI Reg. Analyst | Univest"
                />

                {/* <script
                    dangerouslySetInnerHTML={{
                        __html: `(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TS8KFRM3');`
                    }}
                /> */}
                <script
                    dangerouslySetInnerHTML={{
                        __html: `document.addEventListener('DOMContentLoaded',()=>{setTimeout(initGTM,3500);});
                    document.addEventListener('scroll',initGTMOnEvent);
                    document.addEventListener('mousemove',initGTMOnEvent);
                    document.addEventListener('touchstart',initGTMOnEvent);
                    function initGTMOnEvent(event){initGTM();event.currentTarget.removeEventListener(event.type,initGTMOnEvent);}
                    function initGTM(){
                        if(window.gtmDidInit){
                            return false;
                        }
                        window.gtmDidInit=true;
                        const script=document.createElement('script');
                        script.type='text/javascript';
                        script.async=true;
                        window.dataLayer=window.dataLayer||[];
                        script.onload=()=>{
                            dataLayer.push({event:'gtm.js','gtm.start':(new Date()).getTime(),'gtm.uniqueEventId':0});
                        }
                        script.src='https://www.googletagmanager.com/gtm.js?id=GTM-TS8KFRM3';document.head.appendChild(script);
                    }`
                    }}
                />
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                            document.addEventListener('DOMContentLoaded', initIntelliticks);
                            document.addEventListener('scroll', initIntelliticksOnEvent);
                            document.addEventListener('mousemove', initIntelliticksOnEvent);
                            document.addEventListener('touchstart', initIntelliticksOnEvent);

                            function initIntelliticksOnEvent(event) {
                                initIntelliticks();
                                event.currentTarget.removeEventListener(event.type, initIntelliticksOnEvent);
                            }

                            function initIntelliticks() {
                                if (window.intelliticksDidInit) {
                                    return false;
                                }
                                window.intelliticksDidInit = true;
                                const script = document.createElement('script');
                                script.type = 'text/javascript';
                                script.async = true;
                                script.onload = () => {
                                    (function(I, L, T, i, c, k, s) {
                                        if (I.iticks) return;
                                        I.iticks = { host: c, settings: s, clientId: k, cdn: L, queue: [] };
                                        var h = T.head || T.documentElement;
                                        var e = T.createElement(i);
                                        var l = I.location;
                                        e.async = true;
                                        e.src = (L || c) + '/client/inject-v2.min.js';
                                        h.insertBefore(e, h.firstChild);
                                        I.iticks.call = function(a, b) { I.iticks.queue.push([a, b]); };
                                    })(window, 'https://cdn-v1.intelliticks.com/prod/common', document, 'script', 'https://app.intelliticks.com', 'eFnGRuK7Lxu2qworR_c', {});
                                };
                                document.head.appendChild(script);
                            }
                            `
                    }}
                />

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema ?? defaultSchema) }}
                />
            </Head>

            <noscript
                dangerouslySetInnerHTML={{
                    __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TS8KFRM3" height="0" width="0" style="display: none; visibility: hidden;" />`
                }}
            />

            <style>
                {`
            .iticks-notif-msg{
                z-index:100 !important;
            }
            .iticks-pop-button{
                z-index:100 !important;
                background:#fff !important;
            }
            `}
            </style>

            {/* <Script src="https://www.facebook.com/tr?id=428181756128634&ev=PageView&noscript=1" /> */}
        </>
    );
}
